import React, {useState} from "react";
import {
    Button, ButtonGroup, Input, Popover,
    PopoverArrow, PopoverBody,
    PopoverCloseButton,
    PopoverContent, PopoverFooter,
    PopoverHeader,
    PopoverTrigger
} from "@chakra-ui/react";

function FilterTd({defaultValue='',name, onSubmit,onCancel}) {
    const [value, setValue] = useState(defaultValue);
    return (
        <Popover>
            <PopoverTrigger>
                <Button variant="ghost">
                    {name}
                    <i className="bi bi-funnel-fill mx-1 mt-1"></i>
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow/>
                <PopoverCloseButton/>
                <PopoverHeader>فیلتر</PopoverHeader>
                <PopoverBody>
                    <Input value={value} onChange={(e) => {setValue(e.target.value)}}/>
                </PopoverBody>
                <PopoverFooter className={'justify-content-end'}>
                    <ButtonGroup size='sm'>
                        <Button variant='outline' onClick={onCancel}>پاکسازی</Button>
                        <Button colorScheme='green' onClick={() => {onSubmit(value)}}>ثبت</Button>
                    </ButtonGroup>
                </PopoverFooter>
            </PopoverContent>
        </Popover>
    );
}

export default FilterTd;